import { createUseStyles } from 'react-jss'
import { backgroundColor, color, textSize } from 'styles/helpers'
import config from 'styles/config'

const boxMobileTopMargin = 15
const boxMobileSideMargin = 13

const style = createUseStyles(theme => ({
  notification: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    marginBottom: 20,
    padding: `${boxMobileTopMargin}px ${boxMobileSideMargin}px ${boxMobileTopMargin}px ${boxMobileSideMargin}px`,
    ...backgroundColor('mainBackground'),
    boxShadow: config.colors.contentBoxShadow,
    borderRadius: 2,
    ...textSize(13, 16),

    '&.success': {
      borderLeft: `4px solid ${config.colors.success}`,

      '& $notificationIcon': {
        ...color('success')
      }
    },

    '&.fail': {
      borderLeft: `4px solid ${config.colors.fail}`,

      '& $notificationIcon': {
        ...color('fail')
      }
    }
  },

  notificationIcon: {
    paddingRight: boxMobileTopMargin,
    fontSize: 18
  },
  notificationContent: {
    display: 'flex',
    flexDirection: 'row'
  }
}))

export default style
